import PrimaryButton from "../../../Components/Buttons/primary-button";

import { useModalContext } from "../../../Contexts/ModalContext";

import { modalVariants } from "../../../Utils/constants";

import { StakeCardFrontRotated } from "../../../Assets/Images";

export default function renderStakeSaverCompliance(modalContext, props) {
  const { updateModalComponent, setModalVariant, setModalPromoComponent, setModalTitle, setModalClassName } =
    modalContext;

  updateModalComponent(() => <StakeSaverCompliance {...props} />);
  setModalPromoComponent(null);
  setModalTitle("");
  setModalVariant(modalVariants.flexDialog);
  setModalClassName("position-close-button-over-content light-close-button");
}

const StakeSaverCompliance = ({ onAccept }) => {
  const modalContext = useModalContext();

  const { popModalStack } = modalContext;

  return (
    <>
      <div className="modal-image stake-debit-single-card">
        <img src={StakeCardFrontRotated} alt="" />
      </div>
      <div className="modal-dialog-content">
        <span className="modal-status-title mt-6 mb-2">⚠️ Stake Saver Membership Terms</span>
        <span className="text-base-regular color--mist mb-2">
          Stake Checking comes with premium benefits — including StakePay, Unlimited Cash Back, and more.
        </span>
        <span className="text-base-regular color--mist mb-3">
          As part of this account, you agree to the <span className="text-base-medium">Stake Saver Membership</span>,
          which includes a <span className="text-base-medium">$10 monthly membership fee</span>— automatically waived
          when you do either of the following each month:
        </span>
        <ul className="ps-4 mb-3">
          <li className="text-base-medium color--mist mb-2">Maintain an average balance of $250+, OR</li>
          <li className="text-base-medium color--mist">Pay rent using your Stake Checking account</li>
        </ul>
        <span className="text-base-regular color--mist mb-2">
          If you don’t meet either condition, the $10 fee will apply and appear on your statement.
        </span>
        <span className="text-base-regular color--mist mb-2">
          By tapping “Accept & Continue,” you confirm that you understand and accept these terms.
        </span>
      </div>
      <div className="action-container split-equally">
        <PrimaryButton onClick={onAccept}>Accept & Continue</PrimaryButton>
        <PrimaryButton className="secondary-colors" onClick={() => popModalStack(0)}>
          Cancel
        </PrimaryButton>
      </div>
    </>
  );
};
